export const programTypes = {
  //programTypes - ENUM
  youngScientist: 0,
  regularProgram: 1,
  CollaborativeTrack: 3,
  SoloTrack: 4,
};

export const proposalEligibilityStatus = {
  empty: 0,
  approvedByRA: 100000000,
  approvedByGIF: 100000001,
  notEligible: 100000002,
  submittedByApplicationLeader: 100000003,
  unlockedByRA: 100000004,
  submittedByResearchers: 100000005,
};

export const recommendedBy = {
  Advisor: 100000000,
  GIFsInformationSpecialists: 100000001,
  Referee: 100000002,
  ApplicantSuggestedReviewer: 100000004,
  Other: 100000005,
  ApplicantReviewerNotToBeSent: 100000006,
};

export const PRE_PROPOSAL_STATUS = 957290000;
export const PROPOSAL_STATUS = 1;
export const yearsFields = [
  "firstYearRequestedBudget",
  "secondYearRequestedBudget",
  "thirdYearRequestedBudget",
  "forthYearRequestedBudget",
];
